import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=bea0feaa&scoped=true&"
import script from "./CookieBanner.vue?vue&type=script&lang=js&"
export * from "./CookieBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=bea0feaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea0feaa",
  null
  
)

/* custom blocks */
import block0 from "./CookieBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports